const Utils = {
  addClass: function (element, theClass) {
    element.classList.add(theClass);
  },

  removeClass: function (element, theClass) {
    element.classList.remove(theClass);
  },

  showMore: function (element, excerpt) {
    try {
      element.addEventListener("click", (event) => {
        const linkText = event.target.textContent.toLowerCase();
        event.preventDefault();

        if (linkText == "more +") {
          element.textContent = "less -";
          this.removeClass(excerpt, "excerpt-hidden");
          this.addClass(excerpt, "excerpt-visible");
        } else {
          element.textContent = "more +";
          this.removeClass(excerpt, "excerpt-visible");
          this.addClass(excerpt, "excerpt-hidden");
        }
      });
    } catch (error) {}
  },
};

const ExcerptWidget = {
  showMore: function (showMoreLinksTarget, excerptTarget) {
    const showMoreLinks = document.querySelectorAll(showMoreLinksTarget);

    showMoreLinks.forEach(function (link) {
      const excerpt = link.previousElementSibling.querySelector(excerptTarget);
      Utils.showMore(link, excerpt);
    });
  },
};

ExcerptWidget.showMore(".js-show-more", ".js-excerpt");

document.addEventListener("scroll", handleScroll);
// get a reference to our predefined button
var scrollToTopBtn = document.querySelector(".scrollToTopBtn");

function handleScroll() {
  var scrollableHeight =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;
  var GOLDEN_RATIO = 0.25;

  if (document.documentElement.scrollTop / scrollableHeight > GOLDEN_RATIO) {
    //show button
    scrollToTopBtn.style.display = "block";
  } else {
    //hide button
    scrollToTopBtn.style.display = "none";
  }
}

scrollToTopBtn?.addEventListener("click", scrollToTop);

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

// Tooltips
var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});

// Open external links in new window:

function updateExternalLinks() {
  const links = document.links;

  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
}

updateExternalLinks();
